import { IncentiveCategory } from '@varo/graphql-schema-types';
import SweepstakesIncentiveScreen from 'features/incentive/sweepstakes/screens/SweepstakesIncentiveScreen/SweepstakesIncentiveScreen';

interface IncentiveScreenProps {
  incentiveType: IncentiveCategory;
}

function IncentiveScreen({ incentiveType }: IncentiveScreenProps) {
  switch (incentiveType) {
    case IncentiveCategory.Sweepstakes:
      return <SweepstakesIncentiveScreen />;
  }
}

export default IncentiveScreen;
